import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

//https://www.digitalocean.com/community/tutorials/how-to-set-up-vue-js-authentication-and-route-handling-using-vue-router#step-3-%E2%80%94-updating-the-vue-router-file

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Login",
      meta: { public: true, layout: "auth" },
      component: () => import("./views/Login.vue"),
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      meta: { requiresAuth: true },
      component: () => import("./views/Dashboard.vue"),
    },
    {
      path: "/help",
      name: "Help",
      meta: { requiresAuth: true },
      component: () => import("./views/Help.vue"),
    },
    {
      path: "/fulfilment",
      name: "Fulfilment Orders",
      meta: { requiresAuth: true },
      component: () => import("./views/Fulfilment.vue"),
    },
    {
      path: "/batch-jobs",
      name: "Batch Jobs",
      meta: { requiresAuth: true, is_admin: true },
      component: () => import("./views/BatchJobs.vue"),
    },
    {
      path: "/batch-destination",
      name: "Batch Destination",
      meta: { requiresAuth: true, is_admin: true },
      component: () => import("./views/BatchDestination.vue"),
    },
    {
      path: "/product-config",
      name: "Product Config",
      meta: { requiresAuth: true, is_admin: true },
      component: () => import("./views/ProductConfig.vue"),
    },
    {
      path: "/search-legacy-new",
      name: "Search Order Legacy vs New",
      meta: { requiresAuth: true },
      component: () => import("./views/SearchLegacyNew.vue"),
    },
    {
      path: "/view-user-details/:id",
      name: "View User Details",
      meta: { requiresAuth: true },
      component: () => import("./views/ViewDetails.vue"),
    },
    {
      path: "/page/:id",
      name: "Terms",
      meta: { requiresAuth: true },
      component: () => import("./views/CMSPage.vue"),
    },
    {
      path: "/contact-group",
      name: "Contact Groups",
      meta: { requiresAuth: true, is_admin: true },
      component: () => import("./views/ContactGroups.vue"),
    },
    {
      path: "/campaign-sites",
      name: "Campaign Sites",
      meta: { requiresAuth: true },
      component: () => import("./views/Sites/Sites.vue"),
    },
    {
      path: "/mini-sites",
      name: "Minisites Sites",
      meta: { requiresAuth: true },
      component: () => import("./views/Sites/Sites.vue"),
    },
    {
      path: "/Site/:id",
      name: "SiteEdit",
      meta: { requiresAuth: true },
      component: () => import("./views/Sites/AddEditDomainConfig.vue"),
      props: true,
    },
    {
      path: "/campaign-sites/new",
      name: "CampaignSiteNew",
      meta: { requiresAuth: true },
      component: () => import("./views/Sites/AddEditDomainConfig.vue"),
      props: true,
    },
    {
      path: "/mini-sites/new",
      name: "MiniSiteNew",
      meta: { requiresAuth: true },
      component: () => import("./views/Sites/AddEditDomainConfig.vue"),
      props: true,
    },

    {
      path: '/site/:id',
      name: 'Site',
      meta: { requiresAuth: true, layout: 'campaign-site' },
      component: () => import('./views/Sites/SiteShell.vue'),
      props: true,
      children: [
        {
          path: 'pages',
          name: 'Site Pages',
          meta: { requiresAuth: true, layout: 'campaign-site' },
          component: () => import('./views/Sites/SitePages.vue'),
          props: true,
        },
        {
          path: 'page/:pageid',
          name: 'Site Page',
          meta: { requiresAuth: true, layout: 'campaign-site' },
          component: () => import('./views/Sites/SitePageEdit.vue'),
          props: true,
        },
        {
          path: 'page/new',
          name: 'Site Page New',
          meta: { requiresAuth: true, layout: 'campaign-site' },
          component: () => import('./views/Sites/SitePageEdit.vue'),
          props: true,
        },
        {
          path: 'banners',
          name: 'Banners',
          meta: { requiresAuth: true, layout: 'campaign-site' },
          component: () => import('./views/Sites/SiteOccasionBanners.vue'),
          props: true,
        },
        {
          path: 'banner/:occasionBannerId',
          name: 'BannerEdit',
          meta: { requiresAuth: true, layout: 'campaign-site' },
          component: () => import('./views/Sites/SiteOccasionBannerEdit.vue'),
          props: true,
        },
        {
          path: 'banner/new',
          name: 'BannerNew',
          meta: { requiresAuth: true, layout: 'campaign-site' },
          component: () => import('./views/Sites/SiteOccasionBannerEdit.vue'),
          props: true,
        }
      ],
    }
  ],
});

